import React, { useRef } from 'react'

import { isValidEmail } from 'utils/regex'

import Autocomplete from 'components/Form/Autocomplete'
import Button from 'components/Button'
import FormControl from 'components/Form/FormControl'
import Modal from 'components/Modal'

import styles from './styles.module.scss'

const CreateClientModal = ({
  show,
  toggleModal,
  onSubmit,
  companies
}) => {
  const emailRef = useRef(null)
  const firstNameRef = useRef(null)
  const lastNameRef = useRef(null)
  const companySelectRef = useRef(null)

  const companySelectOptions = companies?.map(
    company => company.name
  )

  const handleCreate = () => {
    const email = (emailRef.current?.value || '').trim()
    if (!isValidEmail(email)) return

    const payload = {
      email,
      firstName:
        (firstNameRef.current?.value || '').trim() || null,
      lastName:
        (lastNameRef.current?.value || '').trim() || null,
      company: companySelectRef.current?.value || null
    }

    onSubmit(payload)
    toggleModal()
  }

  return (
    <Modal show={show} closeModal={toggleModal}>
      <fieldset>
        <p className={styles.modalTitle}>Create Client</p>

        <FormControl
          inputRef={emailRef}
          type="email"
          name="email"
          placeholder="Email"
        />
        <FormControl
          inputRef={firstNameRef}
          type="string"
          name="firstName"
          placeholder="First Name"
        />
        <FormControl
          inputRef={lastNameRef}
          type="string"
          name="lastName"
          placeholder="Last Name"
        />

        <Autocomplete
          inputRef={companySelectRef}
          placeholder="Select Company"
          options={companySelectOptions}
        />

        <div className="d-flex justify-content-end align-items-center">
          <Button
            variant="link"
            smallPadding
            onClick={toggleModal}
          >
            Cancel
          </Button>
          <Button
            variant="secondary"
            smallPadding
            type="submit"
            onClick={handleCreate}
          >
            Create Client
          </Button>
        </div>
      </fieldset>
    </Modal>
  )
}

export default CreateClientModal
